module.exports = __webpack_public_path__ + "img/weixin.6fdf6863.jpg";